export default "__VITE_ASSET__CvXalEaD__"